var map = {
	"./橙-选中@2x.png": "c7e4",
	"./橙@2x.png": "2da5",
	"./红-选中@2x.png": "760a",
	"./红@2x.png": "3fcd",
	"./绿-选中@2x.png": "9fe3",
	"./绿@2x.png": "cb2d",
	"./蓝-选中@2x.png": "dfc6",
	"./蓝@2x.png": "ff3c",
	"./黄-选中@2x.png": "7d26",
	"./黄@2x.png": "00922"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cd9";